import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=18ba64b3&"
import script from "./Controls.vue?vue&type=script&lang=ts&"
export * from "./Controls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports